import React from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { MobileDock } from './MobileDock';
import { ToastContainer } from '../ui/Toast';
import { CommandPalette } from '../ui/CommandPalette';
import { ContextualHelp } from '../ui/ContextualHelp';
import { ChatPanel } from '../../features/ai/components/ChatPanel';
import { useUIStore } from '../lib/uiStore';

interface AppShellProps {
  children: React.ReactNode;
}

export function AppShell({ children }: AppShellProps) {
  const chatOpen = useUIStore((s) => s.chatOpen);
  const toggleChat = useUIStore((s) => s.toggleChat);

  return (
    <div className="relative flex h-screen overflow-hidden bg-surface p-3 gap-3">
      {/* Sidebar */}
      <div className="hidden md:block">
        <Sidebar />
      </div>

      {/* Main area */}
      <div className="flex flex-col flex-1 min-w-0 overflow-hidden rounded-[30px] border border-border bg-surface-raised/65 backdrop-blur-2xl shadow-shell">
        <Header />
        <main className="flex-1 overflow-y-auto">
          <div className="max-w-7xl mx-auto px-4 py-5 pb-24 md:px-6 md:py-6 md:pb-6">
            {children}
          </div>
        </main>
      </div>

      {/* Global overlays */}
      <MobileDock />
      <CommandPalette />
      <ContextualHelp />
      <ChatPanel open={chatOpen} onClose={toggleChat} />
      <ToastContainer />
    </div>
  );
}
